import { type FC } from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

interface Props {
  value: string
  label: string
}

const Subtitle: FC<Props> = ({ value, label }) => (
  <Box flexDirection="row" gap="s16" width="s200">
    <Text size="800" color="grey1000" weight="medium">
      {value}
    </Text>
    <Text.Normal whiteSpace="breakSpaces" color="grey1000" weight="medium">
      {label}
    </Text.Normal>
  </Box>
)

export default Subtitle
